import { Injectable } from '@angular/core';
import { ApiService } from '@core/http';
import { Observable } from 'rxjs';
import { environment } from '@env';

@Injectable({
  providedIn: 'root',
})
export class NotificationsApiProviderService {
  constructor(private apiService: ApiService) {}

  registerToken(token: string): Observable<void> {
    return this.apiService.post(`${environment.environmentVariables.apiCoreUrl}/Notifications/token`, { token });
  }

  removeToken(token: string): Observable<void> {
    return this.apiService.delete(`${environment.environmentVariables.apiCoreUrl}/Notifications/token`, { token });
  }
}
